import { isEmpty, get } from 'lodash';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Button from '../ReusableComponents/Button/Button';
import TextInput from '../ReusableComponents/TextInput/TextInput';
import AdminAPI from '../../Lib/Api/admin';
import LoadingText from '../ReusableComponents/LoadingText/LoadingText';

const useStyles = makeStyles()((theme) => ({
  modal: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    backgroundColor: get(theme, 'palette.white.main'),
    border: '2px solid #000',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    outline: '0',
    padding: '20px',
    width: 600,
  },
  actions: {
    alignItems: 'center',
    display: 'flex',
    flex: '1',
    justifyContent: 'space-between',
    marginTop: '20px',
  },
}));

export default function MessageModal(props) {
  const { classes } = useStyles();
  const { open, onClose } = props;
  const [global, setGlobal] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveText, setSaveText] = useState('Save');

  useEffect(() => {
    if (!isEmpty(global) || !open) return;

    AdminAPI.getGlobal()
      .then((resp) => setGlobal(resp.global))
      .catch(console.log);
  });

  const save = () => {
    setSaving(true);

    AdminAPI.updateGlobal(global)
      .then((resp) => {
        setGlobal(resp.global);
        setSaving(false);
        setSaveText('Saved!');
        setTimeout(() => setSaveText('Save'), 1000);
      })
      .catch(console.log);
  };

  return (
    <Modal open={open} onClose={onClose} className={classes.modal}>
      <div className={classes.container}>
        <TextInput
          fullWidth
          label="Portal Message"
          value={global.portal_message || ''}
          onChange={({ target: { value: msg } }) =>
            setGlobal({ ...global, portal_message: msg })
          }
        />
        <div className={classes.actions}>
          <Button small variant="outlined" color="primary" onClick={save}>
            {saving ? <LoadingText text="Saving" /> : saveText}
          </Button>
          <Button
            small
            variant="outlined"
            color="disableGray"
            onClick={() => onClose()}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}

MessageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
